import * as Yup from 'yup';

import { AdditionalInformationSchema } from '@savgroup-front-common/core/components/AdditionalInformationWithReactHookForm';
import { isFileType } from '@savgroup-front-common/core/helpers/AdditionalInformations/isFileType';
import { RELATED_TO } from '@/types';

const newClaimGroupDocumentPageRelatedToClaimSchema = ({
  reasonSelected,
  isMultiProduct,
}: {
  reasonSelected: any;
  isMultiProduct?: boolean;
}) => {
  const neededInformationFiltered = isMultiProduct
    ? reasonSelected?.neededInformation
        ?.filter(isFileType)
        ?.filter((item: any) => item.relatedTo === RELATED_TO.CLAIM)
    : reasonSelected?.neededInformation?.filter(isFileType);

  const reasonAdditionalInformationSchema = AdditionalInformationSchema({
    neededInformationList: neededInformationFiltered,
  });

  return Yup.object().shape({
    reasonAdditionalInformationDocumentRelatedToClaim:
      reasonAdditionalInformationSchema,
  });
};

export default newClaimGroupDocumentPageRelatedToClaimSchema;
